module.exports = __webpack_public_path__ + "img/img1.0de1a004.png";